import { Box } from '@iheartjane/reefer';
import type { AerosyncWidget } from 'aerosync-web-sdk';
import { useCallback, useEffect, useState } from 'react';
import type { MutableRefObject } from 'react';

import { MultifactorAuthentication } from '@jane/shared/components';
import { useMfa } from '@jane/shared/providers';

import { AeropayLoading } from './aeropayLoading';

export interface AeropayScreenProps {
  afterVerifySuccess?: () => void;
  isLinkingBankAccount: boolean;
  isLoadingWidget: boolean;
  onCancel?: () => void;
  onMfaSuccess?: () => void;
  showCancelButton?: boolean;
  widgetRef: MutableRefObject<AerosyncWidget | null>;
}

export const WIDGET_CONTAINER_ID = 'aerosync-widget';

export const AeropayScreen = ({
  afterVerifySuccess,
  isLinkingBankAccount,
  isLoadingWidget,
  onCancel,
  showCancelButton = true,
  widgetRef,
}: AeropayScreenProps) => {
  const { requiresMfa } = useMfa();
  const [userVerified, setUserVerified] = useState(false);

  const handleVerifySuccess = useCallback(() => {
    setUserVerified(true);
    if (afterVerifySuccess) {
      afterVerifySuccess();
    } else {
      widgetRef.current && widgetRef.current.launch();
    }
  }, [widgetRef]);

  const isLoading = isLinkingBankAccount || isLoadingWidget;

  useEffect(() => {
    if (!isLoadingWidget && !requiresMfa()) {
      handleVerifySuccess();
    }
  }, [isLoadingWidget]);

  return (
    <>
      {isLinkingBankAccount && <AeropayLoading />}

      <Box
        width={userVerified && !isLoading ? '342px' : 'auto'}
        height={userVerified && !isLoading ? '633px' : 'auto'}
      >
        {!userVerified && requiresMfa() && !isLinkingBankAccount && (
          <MultifactorAuthentication
            isLoading={isLoadingWidget}
            onCancel={onCancel}
            onSuccess={handleVerifySuccess}
            showCancelButton={showCancelButton}
          />
        )}

        <div id={WIDGET_CONTAINER_ID}></div>
      </Box>
    </>
  );
};
